import { React, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate, useLocation } from "react-router";
import { useForm } from "react-hook-form";

import ktkService from "../../../services/ktkService";

import { Button } from "../../commonComponents/Buttons";
import InputFields from "../../commonComponents/InputFields/InputFields";
import { UploadedModal } from "../../modals";

import VideoUpload from "../commonPages/VideoUpload/VideoUpload";

function ChildVideoUpload() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();

  const [uploadedModal, setUploadedModal] = useState(false);
  const [videoUploadPercentage, setVideoUploadPercentage] = useState(0);
  const [file, setFile] = useState(null);
  const [fileAccept] = useState({
    "video/mp4": [],
    "video/quicktime": [],
    "video/avi": [],
    "video/webm": [],
  });
  const [fileMaxSize] = useState(524288001); // 500mb size

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    criteriaMode: "all",
    defaultValues: { challenge_title: "" },
  });

  function upload_file(start, path, data) {
    setUploadedModal(true);
    let max_length = 1024 * 1024 * 15;
    let end;
    let existingPath = path;
    let formData = new FormData();
    let nextChunk = start + max_length + 1;
    let currentChunk = file.slice(start, nextChunk);
    let uploadedChunk = start + currentChunk.size;
    if (uploadedChunk >= file.size) {
      end = 1;
    } else {
      end = 0;
    }

    formData.append("video_chunk", currentChunk);
    formData.append("end", end);
    formData.append("existingPath", existingPath);
    formData.append("nextSlice", nextChunk);
    formData.append("videoTitle", data?.challenge_title);
    formData.append("size", file?.size);

    ktkService
      .postNewVideo(location?.state?.channelId, formData)
      .then((res) => {
        if (nextChunk < file.size) {
          existingPath = res.data.existingPath;
          upload_file(nextChunk, existingPath, data);

          setVideoUploadPercentage(
            Math.round((uploadedChunk / file.size) * 100)
          );
        } else {
          if (res.status === 201) {
            setVideoUploadPercentage(100);
          }
        }
      });
  }

  function checkAllData(data) {
    if (data) {
      upload_file(0, null, data);
    }
  }

  return (
    <main className="ktkBg">
      <Button
        label={t("back")}
        iconClassName="hasIcon--chevron-left"
        viewType="backButton"
        onClick={() => navigate(-1)}
      />
      <section className="uploadBlock">
        <h2>{t("uploadNewVideo")}</h2>
        <legend>{t("ktkUploadMsg")}</legend>
        <form onSubmit={handleSubmit(checkAllData)}>
          <fieldset>
            <ul className="formFieldsList">
              <li>
                <InputFields
                  errors={errors}
                  inputType="inputName"
                  register={register}
                  fieldName="challenge_title"
                  lableName={t("videoLabel")}
                />
              </li>
              <li>
                <VideoUpload
                  file={file}
                  setFile={setFile}
                  fileAccept={fileAccept}
                  fileMaxSize={fileMaxSize}
                />
              </li>
              {file && (
                <li>
                  <Button
                    type="submit"
                    label="Upload new video"
                    viewType="mainBtn"
                  />
                </li>
              )}
            </ul>
          </fieldset>
        </form>
      </section>

      {uploadedModal && (
        <UploadedModal uploadType="video" percentage={videoUploadPercentage} />
      )}
    </main>
  );
}

export default ChildVideoUpload;
